export default __webpack_public_path__ + "static/key_b.68e455ca218ef097e3faf3595f394925.svg";